import { BooleanInputStyled, BoxStyled } from 'pages/Gateways/components/GatewaysForm.styled';
import { required } from 'react-admin';
import { NumberInput, TextInput } from 'shared/react-admin/Inputs';

export const GatewaysCreateStatusRequestFields: React.FC = () => (
  <BoxStyled>
    <BooleanInputStyled
      defaultValue={true}
      label="Опрос статуса заказа"
      size="small"
      source="statusRequestEnabled"
      sx={{ alignSelf: 'center' }}
    />
    <NumberInput
      defaultValue={18}
      format={(value) => value || 0}
      fullWidth
      label="Макс. количество попыток опроса"
      parse={(value) => value || 0}
      size="small"
      source="transactionRequestMaxAttempts"
      variant="outlined"
    />
    <TextInput
      defaultValue="5, 10, 15, 20, 40, 60, 120"
      fullWidth
      label="Интервал опроса статуса"
      size="small"
      source="attemptIntervalConfig"
      validate={required()}
      variant="outlined"
    />
    <NumberInput
      defaultValue={600}
      format={(value) => value || 0}
      fullWidth
      label="Срок действия заказа (сек)"
      parse={(value) => value || 0}
      size="small"
      source="orderExpirationTimeSec"
      validate={required()}
      variant="outlined"
    />
  </BoxStyled>
);
